import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from './config.service';
import { environment } from '../../environments/environment'
import { Observable, of, throwError } from 'rxjs';
import { User } from '../models/user.model';
import { first, map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { v4 as uuid } from 'uuid';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient, private _cookieService: CookieService, private configService: ConfigService, private authService: AuthService) {}

  private loadingUser: Promise<any>;
  public user: User;
  public userLoaded: boolean = false;
  public authFailed: boolean = false;
  public errorInAuthentication: boolean = false;

  getUserToken(code: string) {
    console.log("inside userservice");
    return this.httpClient.get(`${environment.apis.thirdParty}/vsp-auth?code=${code}`);
  }

  loadUser(): Observable<User> {
    console.log("inside load userservice");
    
    return this.httpClient.get<any>(`${environment.apis.thirdParty}/users`, { 
      headers: this.authService.authHeaders 
    }).pipe(
      first(),
      map((response: User) => {
        if (!this._cookieService.get('user_session')) {
          this._cookieService.set('user_session', uuid());
        }
  
        this.user = new User(response);
        this.userLoaded = true;
        console.log("this.user", this.user);
  
        return this.user;
      }),
      catchError((error) => {
        this.errorInAuthentication = true;
        console.error('Error loading user:', error);
        // Optionally return a default user or rethrow
        return throwError(() => error); // or `of(null)` if you want to recover gracefully
      })
    );
  }

  loadTonicUser(): Observable<User> {
    return this.httpClient.get<User>(`${environment.apis.thirdParty}/users`).pipe(first(), map((response: User) => {
      if (response == null) {
        this.authFailed = true;
        throw new Error("failed to load Users");
      }
      this.user = new User(response);
      this.user.isAdmin = true;
      // this.user.businessFunction = 'PSC';

      return this.user;
    }))
  }

  public getUser(): User {
    return this.user;
  }
}
